import React, { Component } from 'react';

import Nav from './components/Nav';
import Main from './components/Main';

class App extends Component {
  render() {
    return (
        <div id="wrapper">
            <Nav/>
            <Main></Main>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js